import "./Layout.css"
import React, {JSX} from "react";

type Properties = {
    header?: Array<JSX.Element> | JSX.Element
    headerClasses?: Array<String>
    body?: Array<JSX.Element> | JSX.Element
    bodyClasses?: Array<String>
    leftSide?: Array<JSX.Element> | JSX.Element
    leftSideClasses?: Array<String>
    rightSide?: Array<JSX.Element> | JSX.Element
    rightSideClasses?: Array<String>
    footer?: Array<JSX.Element> | JSX.Element
    footerClasses?: Array<String>
}

function Layout(props: Properties) {
    function additionalClasses(classes: Array<String> | undefined) {
        return classes ? (" " + classes.join(" ")) : ""
    }

    const additionalHeaderClassName = additionalClasses(props.headerClasses)
    const additionalLeftSideClassName = additionalClasses(props.leftSideClasses)
    const additionalBodyClassName = additionalClasses(props.bodyClasses)
    const additionalRightSideClassName = additionalClasses(props.rightSideClasses)
    const additionalFooterClassName = additionalClasses(props.footerClasses)

    return (<>
        <div className="layout">
            {props.header ? (<div className={"header" + additionalHeaderClassName}>{props.header}</div>) : <></>}
            {props.leftSide ? (
                <div className={"leftSide" + additionalLeftSideClassName}>{props.leftSide}</div>) : <></>}
            {props.body ? (<div className={"body" + additionalBodyClassName}>{props.body}</div>) : <></>}
            {props.rightSide ? (
                <div className={"rightSide" + additionalRightSideClassName}>{props.rightSide}</div>) : <></>}
            {props.footer ? (<div className={"footer" + additionalFooterClassName}>{props.footer}</div>) : <></>}
        </div>
    </>)
}


export default Layout